import { useQuery } from "@tanstack/react-query"
import apiClient from "../../../../lib/api_client"

const fetchRestrictedDesigns = async ({ queryKey }) => {
  const [, orderId] = queryKey
  const { data } = await apiClient.get(`/getGatiRestricatedStyles/${orderId}`)
  return data?.orderData || []
}

export const useGatiRestrictData = ({ type, orderId, Open }) => {
  return useQuery({
    queryKey: ["restricted-styles", orderId],
    queryFn: () =>
      fetchRestrictedDesigns({ queryKey: ["restricted-styles", orderId] }),
    enabled: type === "restrict" && !!orderId && Open,
  })
}
